import { InjectionToken } from '@angular/core';

import type { ClientEnvironment } from '../types/environment';

export const CLIENT_ENVIRONMENT = new InjectionToken<ClientEnvironment>('CLIENT_ENVIRONMENT');
